import AccessCodeForm from '../../components/onboarding/AccessCodeForm'
import FormLayout from '../../layouts/FormLayout'

const VerifyAccessCodeScreen = ({ route }) => {
  const { userEmail, email, codeEmailed } = route.params

  return (
    <FormLayout bg="white">
      <AccessCodeForm
        userEmail={userEmail}
        email={email}
        codeEmailed={codeEmailed}
      />
    </FormLayout>
  )
}

export default VerifyAccessCodeScreen
